import _get from 'lodash/get';

export const getAlternativeFare = quoteV2 =>
  _get(quoteV2, 'alternativeFare[0]');

export const getOptimizedSteps = alternativeFare =>
  _get(
    alternativeFare,
    'routeOptimization.OptimizedSteps',
    _get(alternativeFare, 'routeOptimization.optimizedSteps', []),
  );

export const getOptimizedRecipientOrder = quoteV2 =>
  getOptimizedSteps(getAlternativeFare(quoteV2))
    .slice(1)
    .map((i, _, steps) => {
      if (i === 0) {
        // for round trip case
        return steps.length - 1;
      }
      return i - 1;
    });

export const checkAlreadyOptimized = quoteV2 =>
  _get(quoteV2, 'alternativeFare[0]');

export default {};
